import { Api } from 'domain/core';
import { assert } from 'domain/utils';
import { AuthorizedService } from './authorized-service.base';
import { useEffect, useState } from 'react';
import { User } from 'domain/models';

export class AccountService extends AuthorizedService {

  /**
   * Get current user account details
   */
  public async getCurrent(): Promise<User> {
    return await this.fetch(
      Api.baseUrl + Api.auth.account
    )
      .then((r) => r.json())
      .then((json) => {
        return json;
      });
  }
}
